"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenHistory = void 0;
const TokenHistoryList_1 = require("./TokenHistoryList");
class TokenHistory {
    constructor(data) {
        this.displayTicketNumber = null;
        this.playable = data.playable;
        this.ticketEntry = data.ticketEntry;
        this.token = data.token;
    }
}
exports.TokenHistory = TokenHistory;
TokenHistory.toJsonList = (data) => {
    const tokenHistoryList = new TokenHistoryList_1.TokenHistoryList();
    data.forEach(token => {
        tokenHistoryList.push(TokenHistory.toJson(token));
    });
    return tokenHistoryList.getFormattedData();
};
TokenHistory.toJson = (data) => new TokenHistory(data);
//# sourceMappingURL=TokenHistory.js.map